import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";
import { VISITOR_API_ROUTES } from "../utils/visitorApiRoutes";
import { authJsonHeaders, buildApiError, parseJson } from "./apiHelpers";

const BASE = VISITOR_API_ROUTES.visitorIdProof;

export async function getVisitorIdProofTypes() {
  const res = await authFetch(BASE, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to fetch ID proof types");
  return data;
}

export async function createVisitorIdProofType(body, csrfToken) {
  const res = await authFetch(BASE, {
    method: "POST",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to create ID proof type");
  return data;
}

export async function updateVisitorIdProofType(id, body, csrfToken) {
  const res = await authFetch(`${BASE}/${encodeURIComponent(String(id))}`, {
    method: "PUT",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to update ID proof type");
  return data;
}

export async function deleteVisitorIdProofType(id, csrfToken) {
  const res = await authFetch(`${BASE}/${encodeURIComponent(String(id))}`, {
    method: "DELETE",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to delete ID proof type");
  return data;
}
